import {
  Box,
  type Disclosure,
  TextLinkButton,
  Text,
  Stack,
  IconChevron,
} from 'braid-design-system';
import { useState, type ComponentProps, type FC } from 'react';

interface SmallDisclosureProps {
  id: ComponentProps<typeof Disclosure>['id'];
  expandLabel: ComponentProps<typeof Disclosure>['expandLabel'];
  collapseLabel: ComponentProps<typeof Disclosure>['collapseLabel'];
  weight?: ComponentProps<typeof TextLinkButton>['weight'];
  data?: ComponentProps<typeof Disclosure>['data'];
  children: ComponentProps<typeof Disclosure>['children'];
}

// FIXME: Remove when Braid supports `small` disclosures!
export const SmallDisclosure: FC<SmallDisclosureProps> = ({
  id,
  expandLabel,
  collapseLabel,
  weight,
  data,
  children,
}) => {
  const [expanded, setExpanded] = useState(false);
  return (
    <Stack space="small" data={data}>
      <Text size="small">
        <TextLinkButton
          weight={weight}
          onClick={() => {
            setExpanded((prev) => !prev);
          }}
          aria-expanded={expanded}
          aria-controls={id}
        >
          {expanded ? collapseLabel : expandLabel}{' '}
          <IconChevron direction={expanded ? 'up' : 'down'} />
        </TextLinkButton>
      </Text>
      <Box id={id} display={expanded ? 'block' : 'none'}>
        {children}
      </Box>
    </Stack>
  );
};
